import { UseQueryResult } from 'react-query';
import { LouiseSessionObject } from '../../../../types/ProductFactory';
import useQueryFetch from '../../../common/src/hooks/useQueryFetch';
import { getFlowSessionById } from '../services/louiseApiService';
import { OFFERS_CACHE_TIME } from './useQuoteQueries';

export const useFlowSessionObject = (
  sessionId?: string,
  enabled = true,
): UseQueryResult<LouiseSessionObject, unknown> =>
  useQueryFetch<LouiseSessionObject>({
    queryKey: ['session', sessionId],
    fetchFn: () => getFlowSessionById(sessionId as string),
    options: {
      staleTime: Infinity,
      cacheTime: OFFERS_CACHE_TIME,
      refetchOnWindowFocus: false,
      enabled,
    },
  });
